import { GetQualifiedInvoiceDetailPaymentQuery } from "@graffer-inc/smart-apply";
import { PreviewQualifiedInvoice } from "../../../../../organisms/smart-apply/qualified-invoice/preview";
import { useQualifiedInvoiceNewPreviewContainer } from "./hooks";

type Props = {
  applicationId: string;
  procedureId: string;
  groupId: string;
  buyerName: string;
  transactionDate: {
    year: number;
    month: number;
    day: number;
  };
  detailPayment: NonNullable<
    GetQualifiedInvoiceDetailPaymentQuery["qualifiedInvoiceDetailPayment"]
  >;
};

export const QualifiedInvoiceNewPreviewContainer: React.FC<Props> = ({
  applicationId,
  procedureId,
  groupId,
  buyerName,
  transactionDate,
  detailPayment,
}) => {
  const { businessIssuer } = useQualifiedInvoiceNewPreviewContainer({
    applicationId: applicationId,
    procedureId,
    groupId,
  });

  if (!businessIssuer) {
    return null;
  }

  return (
    <PreviewQualifiedInvoice
      buyerName={buyerName}
      businessIssuer={businessIssuer}
      transactionDate={`${transactionDate.year}年${transactionDate.month}月${transactionDate.day}日`}
      detailPayment={detailPayment}
    />
  );
};
